export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热播推荐', href: '#cards' },
  { label: '热门话题', href: '#topics' },
  { label: '分类索引', href: '#index' },
  { label: '常见问题', href: '#faq' },
  { label: '观众热评', href: '#comments' },
  { label: '联系我们', href: '#contact' },
];

export const heroData = {
  tag: '全网热播 · 每日更新',
  title: '草民影院 - 免费高清影视在线观看平台',
  slogan: '追剧不等待，看片不花钱',
  description:
    '草民影院汇集海量高清影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。每日实时更新最新热播剧集与院线大片，1080P高清画质流畅不卡顿，无需注册付费，打开即看。无论是最新上映的国产热剧、海外精选高分剧集，还是经典怀旧老片、小众独立电影，草民影院都能满足你的观影需求。目前平台已收录超过10000部影视作品，覆盖动作、喜剧、悬疑、科幻、爱情、战争、纪录片等全类型。我们坚持免费高清的核心理念，让每一位影迷都能轻松享受优质影视内容，告别付费墙和冗长广告的困扰。',
  stats: [
    { value: '10000+', label: '影视资源' },
    { value: '每日更新 50+', label: '最新剧集' },
    { value: '1080P', label: '高清画质' },
  ],
  primaryCta: { label: '开始观看', href: '#cards' },
  secondaryCta: { label: '查看榜单', href: '#ranking' },
};

export const cards = [
  {
    title: '星际征途：暗域降临',
    category: '科幻 · 动作',
    rating: '9.2',
    desc: '人类首次接触外星文明，一场关乎存亡的星际战争即将爆发，最震撼的视觉奇观不容错过。',
    image:
      'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20astronaut%20silhouette%20against%20cosmic%20nebula%20and%20distant%20planets%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20cinematic%20composition%2C%20minimalist%20film%20poster%20design%2C%20clean%20gradient%20background%2C%20movie%20poster%20aesthetic%20with%20professional%20typography%20space&width=800&height=1200&seq=card-movie-01&orientation=portrait',
  },
  {
    title: '长安十二时辰之天火',
    category: '古装 · 悬疑',
    rating: '8.9',
    desc: '繁华长安暗藏杀机，一桩离奇的宫廷命案牵扯出惊天阴谋，层层反转令人拍案叫绝。',
    image:
      'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20palace%20silhouette%20at%20sunset%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20traditional%20Chinese%20architecture%20outline%2C%20mysterious%20atmosphere%2C%20minimalist%20oriental%20film%20poster%20design%2C%20elegant%20composition%20with%20soft%20gradient&width=800&height=1200&seq=card-movie-02&orientation=portrait',
  },
  {
    title: '深海迷踪',
    category: '冒险 · 惊悚',
    rating: '8.7',
    desc: '一支科考队在万米深海遭遇未知生物，密闭空间内的生死逃亡拉开序幕，全程高能无尿点。',
    image:
      'https://readdy.ai/api/search-image?query=Underwater%20thriller%20movie%20poster%20with%20deep%20ocean%20blue%20gradient%20and%20mysterious%20creature%20silhouette%2C%20submarine%20lights%20piercing%20darkness%2C%20suspenseful%20cinematic%20atmosphere%2C%20minimalist%20poster%20design%2C%20cool%20teal%20and%20navy%20tones%20with%20dramatic%20light%20rays&width=800&height=1200&seq=card-movie-03&orientation=portrait',
  },
  {
    title: '你好，旧时光',
    category: '青春 · 爱情',
    rating: '8.5',
    desc: '一段跨越十年的校园暗恋，在毕业季的重逢中重新点燃，温暖治愈的青春回忆杀。',
    image:
      'https://readdy.ai/api/search-image?query=Youth%20romance%20movie%20poster%20with%20two%20silhouettes%20under%20cherry%20blossom%20tree%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20nostalgic%20school%20campus%20background%2C%20soft%20dreamy%20atmosphere%2C%20minimalist%20poster%20design%2C%20gentle%20pink%20and%20amber%20tones&width=800&height=1200&seq=card-movie-04&orientation=portrait',
  },
  {
    title: '铁血战狼：终极使命',
    category: '军事 · 战争',
    rating: '9.0',
    desc: '精英特种部队深入敌后执行绝密营救，枪林弹雨中谱写铁血传奇，国产军事片巅峰之作。',
    image:
      'https://readdy.ai/api/search-image?query=Military%20action%20movie%20poster%20with%20soldier%20silhouette%20against%20dramatic%20smoke%20and%20fire%20background%2C%20camouflage%20green%20and%20orange%20tones%2C%20intense%20combat%20atmosphere%2C%20minimalist%20war%20film%20poster%20design%2C%20powerful%20heroic%20composition%2C%20cinematic%20style&width=800&height=1200&seq=card-movie-05&orientation=portrait',
  },
  {
    title: '笑傲江湖之风云再起',
    category: '武侠 · 喜剧',
    rating: '8.8',
    desc: '经典武侠IP全新演绎，江湖恩怨与爆笑桥段交织，既有刀光剑影也有捧腹大笑。',
    image:
      'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20movie%20poster%20with%20swordsman%20silhouette%20on%20misty%20mountain%20peak%2C%20ink%20wash%20painting%20style%2C%20elegant%20oriental%20aesthetic%2C%20dramatic%20clouds%20and%20moonlight%2C%20minimalist%20wuxia%20film%20poster%2C%20black%20white%20and%20gold%20tones&width=800&height=1200&seq=card-movie-06&orientation=portrait',
  },
  {
    title: '我的人间烟火',
    category: '都市 · 情感',
    rating: '9.1',
    desc: '消防员与医生的都市爱情故事，在生死救援中见证最真挚的感情，年度催泪治愈神剧。',
    image:
      'https://readdy.ai/api/search-image?query=Urban%20romance%20drama%20poster%20with%20city%20skyline%20at%20dusk%2C%20warm%20window%20lights%2C%20couple%20silhouettes%20on%20rooftop%2C%20emotional%20healing%20atmosphere%2C%20soft%20golden%20and%20rose%20tones%2C%20minimalist%20modern%20film%20poster%20design%2C%20cinematic%20composition&width=800&height=1200&seq=card-movie-07&orientation=portrait',
  },
];

export const comments = [
  {
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20profile%20avatar%20portrait%2C%20warm%20lighting%2C%20film%20enthusiast%20style%2C%20minimalist%20headshot%2C%20soft%20background&width=100&height=100&seq=avatar-comment-01&orientation=squarish',
    date: '2026-07-28',
    rating: 5,
    content: '用了草民影院三年了，资源更新速度真的快，基本上热门剧播出当晚就能看到高清版。画质也很稳定，基本没有卡顿的情况。',
  },
  {
    name: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Movie%20lover%20profile%20avatar%2C%20warm%20tone%20portrait%2C%20cinema%20enthusiast%2C%20soft%20lighting%2C%20minimalist%20headshot%20style&width=100&height=100&seq=avatar-comment-02&orientation=squarish',
    date: '2026-07-26',
    rating: 5,
    content: '分类做得特别细致，找片很方便。科幻迷狂喜，很多冷门科幻片这里都能找到。推荐给了好多朋友，都说好用。',
  },
  {
    name: '午夜放映员',
    avatar: 'https://readdy.ai/api/search-image?query=Film%20critic%20profile%20avatar%20portrait%2C%20cinematic%20lighting%2C%20artsy%20style%2C%20minimalist%20headshot%2C%20warm%20background%20tone&width=100&height=100&seq=avatar-comment-03&orientation=squarish',
    date: '2026-07-25',
    rating: 4,
    content: '纪录片频道做得越来越好了，BBC和NHK的经典纪录片基本都能找到。希望后续能增加更多独立电影的片源。',
  },
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20woman%20profile%20avatar%2C%20warm%20lighting%2C%20modern%20style%2C%20minimalist%20portrait%2C%20soft%20background%2C%20cinematic%20tone&width=100&height=100&seq=avatar-comment-04&orientation=squarish',
    date: '2026-07-24',
    rating: 5,
    content: '最大的好处就是完全免费！以前在别的平台追剧动不动就要充会员，这里不但免费画质还更好，真的是良心平台。',
  },
  {
    name: '电影老炮儿',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20man%20profile%20avatar%2C%20warm%20portrait%20lighting%2C%20classic%20film%20fan%20style%2C%20minimalist%20headshot%2C%20soft%20background&width=100&height=100&seq=avatar-comment-05&orientation=squarish',
    date: '2026-07-22',
    rating: 5,
    content: '作为一个看了三十年电影的老影迷，草民影院的片库深度让我很惊喜。很多八九十年代的经典老片都有收录，值得点赞。',
  },
];

export const aboutData = {
  title: '关于草民影院',
  paragraphs: [
    '草民影院创立于2020年，是国内领先的免费高清影视在线观看平台。我们致力于为广大影迷提供海量优质影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。平台坚持"免费、高清、流畅"的核心理念，无需用户注册付费即可畅享影院级观影体验。',
    '经过多年的积累与发展，草民影院已收录超过10000部影视作品，覆盖动作、喜剧、悬疑、科幻、爱情、战争、纪录片等全类型内容。我们拥有专业的资源更新团队，每日实时更新最新热播剧集与院线大片，确保用户第一时间看到想看的内容。',
    '草民影院采用先进的视频压缩与分发技术，支持1080P高清画质流畅播放。我们不断优化播放体验，减少缓冲等待时间，让每一位用户都能享受丝滑的观影过程。未来，草民影院将继续拓展片源类型、提升服务质量，努力成为最受用户信赖的免费影视平台。',
  ],
};

export const contactData = {
  title: '联系我们',
  description: '如果你有影片推荐、资源反馈、合作建议或任何问题，欢迎通过以下方式联系我们。',
  email: 'contact@caominyingyuan.com',
  items: [
    { icon: 'ri-mail-line', label: '商务合作', value: 'business@caominyingyuan.com' },
    { icon: 'ri-feedback-line', label: '内容反馈', value: 'feedback@caominyingyuan.com' },
    { icon: 'ri-wechat-line', label: '微信公众号', value: '草民影院' },
    { icon: 'ri-tiktok-line', label: '抖音号', value: '@caominyingyuan' },
  ],
};

export const faqItems = [
  {
    question: '草民影院需要注册或付费吗？',
    answer: '完全不需要。草民影院坚持免费开放的运营理念，所有影视资源均可免费在线观看，无需注册账号，无需支付任何费用，打开网站即可畅享全部内容。',
  },
  {
    question: '影片画质如何？是否支持高清播放？',
    answer: '草民影院全线支持1080P高清画质播放。我们采用先进的视频压缩与CDN分发技术，在保证高清画质的同时确保播放流畅不卡顿。大部分热门影片还提供720P和1080P多档画质选择。',
  },
  {
    question: '多久更新一次内容？新片上线速度快吗？',
    answer: '草民影院拥有专业的内容更新团队，每日实时更新最新影视资源。热门国产剧一般在播出后数小时内上线，院线新片也会在上映后尽快更新。日均更新50部以上影视内容。',
  },
  {
    question: '支持哪些设备观看？有手机APP吗？',
    answer: '草民影院采用响应式网页设计，完美适配电脑、平板和手机浏览器。您无需下载任何APP，在任意设备的浏览器中打开即可享受流畅的观影体验。同时我们也提供移动端专属页面，操作更加便捷。',
  },
  {
    question: '资源加载慢或无法播放怎么办？',
    answer: '建议您先检查网络连接是否正常，或尝试切换播放线路。草民影院为大部分影片提供了多条备用播放线路，点击播放器下方的线路切换按钮即可更换。如问题持续存在，欢迎通过反馈渠道联系我们。',
  },
  {
    question: '可以下载影片离线观看吗？',
    answer: '草民影院为在线观看平台，暂不提供影片下载功能。但我们支持断点续播，您上次观看的进度会自动保存，下次打开即可继续观看。移动端用户可添加网站到手机主屏幕，获得接近APP的使用体验。',
  },
];

export const mediaItems = [
  {
    title: '星际征途：暗域降临 - 终极预告',
    duration: '2:35',
    views: '128万',
    image:
      'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20trailer%20thumbnail%20with%20spaceship%20battle%20scene%2C%20dramatic%20cosmic%20explosion%20lighting%2C%20cinematic%20widescreen%20composition%2C%20dark%20space%20background%20with%20golden%20explosion%20highlights%2C%20professional%20film%20trailer%20thumbnail%20style&width=800&height=450&seq=media-trailer-01&orientation=landscape',
  },
  {
    title: '长安十二时辰之天火 - 幕后特辑',
    duration: '4:12',
    views: '96万',
    image:
      'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20behind%20the%20scenes%20thumbnail%2C%20director%20and%20actors%20in%20traditional%20costumes%2C%20warm%20golden%20set%20lighting%2C%20cinematic%20widescreen%2C%20professional%20film%20making%20documentary%20style%2C%20rich%20amber%20tones&width=800&height=450&seq=media-trailer-02&orientation=landscape',
  },
  {
    title: '深海迷踪 - 导演专访',
    duration: '6:48',
    views: '73万',
    image:
      'https://readdy.ai/api/search-image?query=Film%20director%20interview%20thumbnail%2C%20professional%20studio%20lighting%2C%20underwater%20movie%20theme%2C%20cinematic%20widescreen%20composition%2C%20warm%20interview%20atmosphere%2C%20deep%20blue%20and%20amber%20accent%20tones&width=800&height=450&seq=media-trailer-03&orientation=landscape',
  },
  {
    title: '2026暑期档精彩混剪',
    duration: '3:20',
    views: '156万',
    image:
      'https://readdy.ai/api/search-image?query=Summer%20movie%20montage%20thumbnail%2C%20action%20scenes%20collage%2C%20cinematic%20film%20reel%20aesthetic%2C%20warm%20golden%20hour%20cinema%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20movie%20trailer%20compilation%20style&width=800&height=450&seq=media-trailer-04&orientation=landscape',
  },
];

export const rankingItems = [
  { rank: 1, title: '星际征途：暗域降临', hot: '986万', category: '科幻', trending: 'up' },
  { rank: 2, title: '我的人间烟火', hot: '872万', category: '都市', trending: 'up' },
  { rank: 3, title: '笑傲江湖之风云再起', hot: '765万', category: '武侠', trending: 'up' },
  { rank: 4, title: '长安十二时辰之天火', hot: '698万', category: '古装', trending: 'stable' },
  { rank: 5, title: '铁血战狼：终极使命', hot: '632万', category: '军事', trending: 'down' },
  { rank: 6, title: '深海迷踪', hot: '589万', category: '惊悚', trending: 'up' },
];

export const updates = [
  {
    date: '2026-07-31',
    content: '《星际征途：暗域降临》4K修复版现已上线，视觉效果全面升级',
    tag: '新片上线',
  },
  {
    date: '2026-07-30',
    content: '暑期档专题页面上线，精选50部高分热门影片一站式观看',
    tag: '专题活动',
  },
  {
    date: '2026-07-29',
    content: '播放器全面升级至V3.0版本，新增倍速播放和记忆续播功能',
    tag: '功能更新',
  },
  {
    date: '2026-07-28',
    content: '纪录片频道新增BBC《蓝色星球》全系列，高清双语字幕',
    tag: '片源更新',
  },
  {
    date: '2026-07-27',
    content: '《长安十二时辰之天火》上线首日播放量突破500万',
    tag: '热播资讯',
  },
  {
    date: '2026-07-26',
    content: '移动端观影体验优化，适配所有主流手机浏览器',
    tag: '体验升级',
  },
  {
    date: '2026-07-25',
    content: '经典港片专区整理完毕，周星驰、成龙等经典作品全收录',
    tag: '专区上线',
  },
  {
    date: '2026-07-24',
    content: '服务器集群扩容完成，高峰期观影流畅度提升40%',
    tag: '系统升级',
  },
];

export const features = [
  {
    icon: 'ri-movie-2-line',
    title: '海量片源',
    desc: '收录超过10000部影视作品，涵盖电影、电视剧、综艺、动漫、纪录片等全品类，满足各类观影需求。',
  },
  {
    icon: 'ri-4k-line',
    title: '1080P高清',
    desc: '全线支持1080P高清画质，采用先进编码技术，在保证清晰度的同时优化带宽消耗，流畅不卡顿。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '专业资源团队实时监控，热门剧集播出后数小时内上线，日均更新50部以上，追剧永不错过。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美支持电脑、平板和手机浏览器，响应式设计自适应屏幕尺寸，随时随地畅享观影。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '纯净观影环境，无弹窗广告、无恶意跳转，全程加密传输保护用户隐私，安全放心观看。',
  },
];

export const topics = [
  { name: '暑期档推荐', count: '50部', hot: true },
  { name: '国产科幻崛起', count: '32部', hot: true },
  { name: '高分悬疑片单', count: '28部', hot: false },
  { name: '经典港片回顾', count: '65部', hot: false },
  { name: '治愈系日剧', count: '21部', hot: true },
  { name: 'BBC纪录片精选', count: '18部', hot: false },
  { name: '武侠电影合集', count: '43部', hot: false },
  { name: '青春校园剧', count: '36部', hot: true },
  { name: '好莱坞动作大片', count: '55部', hot: false },
];

export const carouselItems = [
  {
    title: '科幻迷必看：十大硬核科幻电影',
    desc: '从《2001太空漫游》到《星际征途》，盘点那些改变科幻电影史的里程碑之作',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20collection%20composition%2C%20futuristic%20space%20theme%2C%20dramatic%20nebula%20colors%2C%20film%20reel%20aesthetic%2C%20warm%20golden%20and%20deep%20blue%20cosmic%20gradients%2C%20professional%20movie%20banner%20design%2C%20cinematic%20widescreen&width=1200&height=600&seq=carousel-featured-01&orientation=landscape',
  },
  {
    title: '2026暑期档：这个夏天值得追的剧',
    desc: '精选今夏最热国产剧和海外剧，从古装悬疑到都市爱情，你的夏日追剧清单已就位',
    image:
      'https://readdy.ai/api/search-image?query=Summer%20movie%20and%20drama%20collection%20composition%2C%20warm%20sunset%20cinema%20aesthetic%2C%20film%20posters%20collage%20style%2C%20golden%20hour%20lighting%2C%20professional%20entertainment%20banner%20design%2C%20vibrant%20warm%20tones&width=1200&height=600&seq=carousel-featured-02&orientation=landscape',
  },
  {
    title: '国产动画崛起：不可错过的国漫精品',
    desc: '从大圣归来到深海，从哪吒到长安三万里，见证国产动画电影的黄金时代',
    image:
      'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20collection%20composition%2C%20ink%20wash%20painting%20style%2C%20traditional%20oriental%20art%20aesthetic%2C%20warm%20amber%20and%20crimson%20gradients%2C%20cinematic%20banner%20design%2C%20mythological%20theme%20with%20golden%20highlights&width=1200&height=600&seq=carousel-featured-03&orientation=landscape',
  },
  {
    title: '永不褪色的经典：华语电影百年精选',
    desc: '重温张艺谋、王家卫、杨德昌等大师的传世之作，感受华语电影的独特魅力',
    image:
      'https://readdy.ai/api/search-image?query=Classic%20Chinese%20cinema%20collection%20composition%2C%20vintage%20film%20aesthetic%2C%20warm%20nostalgic%20tones%2C%20film%20grain%20texture%2C%20historic%20movie%20scenes%20collage%2C%20elegant%20retro%20banner%20design%2C%20sepia%20and%20golden%20gradients&width=1200&height=600&seq=carousel-featured-04&orientation=landscape',
  },
  {
    title: '全球纪录片精选：打开世界的另一扇窗',
    desc: 'BBC、NHK、Discovery经典纪录片合集，涵盖自然、历史、科技、人文四大维度',
    image:
      'https://readdy.ai/api/search-image?query=Nature%20documentary%20collection%20composition%2C%20wildlife%20and%20landscape%20cinematography%2C%20warm%20earthy%20tones%2C%20professional%20documentary%20banner%20design%2C%20aerial%20cinematography%20aesthetic%2C%20golden%20hour%20nature%20scenes&width=1200&height=600&seq=carousel-featured-05&orientation=landscape',
  },
];

export const indexItems = [
  { title: '动作片', icon: 'ri-sword-line', count: '1,286部', href: '#cards' },
  { title: '喜剧片', icon: 'ri-emotion-laugh-line', count: '952部', href: '#cards' },
  { title: '科幻片', icon: 'ri-rocket-line', count: '743部', href: '#cards' },
  { title: '爱情片', icon: 'ri-heart-line', count: '1,102部', href: '#cards' },
  { title: '悬疑片', icon: 'ri-search-eye-line', count: '867部', href: '#cards' },
  { title: '恐怖片', icon: 'ri-ghost-line', count: '534部', href: '#cards' },
  { title: '战争片', icon: 'ri-flag-2-line', count: '421部', href: '#cards' },
  { title: '纪录片', icon: 'ri-camera-lens-line', count: '689部', href: '#cards' },
  { title: '动画片', icon: 'ri-palette-line', count: '1,045部', href: '#cards' },
];

export const appData = {
  title: '随时随地 畅享观影',
  description: '草民影院完美适配手机浏览器，无需下载APP，打开浏览器即可观看。添加至手机主屏幕，获得接近原生APP的流畅体验。',
  features: ['免下载安装', '全机型适配', '省流量模式', '断点续播'],
  image:
    'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20movie%20streaming%20app%20interface%2C%20modern%20minimalist%20UI%20design%2C%20film%20posters%20on%20screen%2C%20warm%20lighting%2C%20device%20mockup%20on%20clean%20background%2C%20cinematic%20color%20scheme%2C%20professional%20product%20photography&width=800&height=600&seq=app-mobile-mockup&orientation=portrait',
};

export const footerData = {
  description:
    '草民影院 - 免费高清影视在线观看平台。海量电影、电视剧、综艺、动漫、纪录片免费看，1080P高清画质，每日更新，无需注册付费。',
  quickLinks: [
    { label: '热播推荐', href: '#cards' },
    { label: '热门话题', href: '#topics' },
    { label: '分类索引', href: '#index' },
    { label: '常见问题', href: '#faq' },
    { label: '观众热评', href: '#comments' },
    { label: '联系我们', href: '#contact' },
  ],
};